/**
 * Labstep
 *
 * @module components/Layout/Alert/StagingContent
 * @desc Displays a warning to the user that they are on staging
 */

import { withAuthenticatedUser } from 'labstep-web/containers/AuthenticatedUser';
import { Alert } from 'labstep-web/core/Alert';
export const StagingWarning = () => (
  <Alert color="orange" centered noMargin>
    You seem to be on staging, changes made here won&apos;t be saved.
  </Alert>
);

export const allowedUser = (username) =>
  username.endsWith('@labstep.com');

export const StagingContentComponent = ({ authenticatedUser }) =>
  window.location.host.includes('staging') &&
  authenticatedUser &&
  authenticatedUser.username &&
  !allowedUser(authenticatedUser.username) && <StagingWarning />;

export default withAuthenticatedUser(StagingContentComponent);
